// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle." + {"24":"6146cb82ec94f7f242e8","296":"f6b1aa4ca3ae87946262","660":"7ef8d79ae4ae8ac38b62"}[chunkId] + ".js";
};